/**
 * @file menuPlacement.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-21
 * @modified 2026-10-21
 * @description Where a popup menu goes vertically (Cam, 21 Oct 2026 — the
 *              right-click and ⋮ menus in Pricing & Costing opened downward
 *              off the bottom of the panel instead of flipping up). One rule
 *              for TableContextMenu and RowActionsMenu: open below the anchor
 *              when it fits above the fixed status bar (or the window's foot),
 *              else above it; when it fits neither way, the side with more
 *              room, clamped inside the window. Pure apart from reading the
 *              status bar's position.
 */

export const MENU_PAD = 8;

/** The lowest y a menu may reach: the top of the fixed status bar, else the window's foot. */
export function menuBottomLimit(pad = MENU_PAD) {
  const vh = typeof window !== 'undefined' ? window.innerHeight : 0;
  let limit = vh;
  if (typeof document !== 'undefined') {
    const bar = document.querySelector('.status-bar');
    if (bar) {
      const r = bar.getBoundingClientRect();
      if (r.height > 0 && r.top > 0 && r.top < limit) limit = r.top;
    }
  }
  return limit - pad;
}

/**
 * The menu's top for an anchor spanning anchorTop..anchorBottom (a click point
 * is both). Below when it fits, else above, else whichever side has more room.
 */
export function placeVertically({ anchorTop, anchorBottom, height, gap = 0, pad = MENU_PAD, bottomLimit = menuBottomLimit(pad) }) {
  const below = anchorBottom + gap;
  if (below + height <= bottomLimit) return below;
  const above = anchorTop - gap - height;
  if (above >= pad) return above;
  const roomBelow = bottomLimit - below;
  const roomAbove = anchorTop - gap - pad;
  return roomAbove > roomBelow ? pad : Math.max(pad, Math.min(below, bottomLimit - height));
}
